export const MentorshipEndpoints = {
  getSessions: (slug: string) => `${process.env.BASE_URL}/rest/v1/mentorship/membership/${slug}`
}
